<template>
  <div class="wrapper">
    <Validation-Observer
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="login()"
    >
      <div class="flex justify-center mb-6">
        <div class="w-1/4 bg-gray-100 bg-opacity-50 h-auto">
          <div class="flex justify-center mb-4 mt-12" style="max-height: 10rem">
            <img src="../../assets/img/MOH_logo.png" style="max-height: 7rem"/>
          </div>
          <div class="self-center justify-center text-center">
            <div class="text--primary font-weight-medium">
              ወደ HRD እንኳን በደህና መጡ!
            </div>
            <div class="text--primary font-weight-medium">Welcome to HRD!</div>
          </div>
        </div>
        <div class="w-full md:w-1/4 bg-gray-500">
          <div class="form">
            <div class="self-center justify-center text-center">
              <p class="font-serif text-lg text-white-800 text-center py-2">
                Reset Password
              </p>
            </div>
            <form>
              <div class="mb-6">
                <label class="block text-white-700 text-sm font-bold mb-2"
                >Password</label
                >
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    vid="confirm"
                >
                  <div class="input-icons">
                    <input
                        v-if="showPassword"
                        v-model="resetPassword.password"
                        class="
                    input-field
                    shadow
                    appearance-none
                    border
                    rounded
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline"
                        name="password"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="text"
                    />
                    <input
                        v-else
                        v-model="resetPassword.password"
                        class="
                    input-field
                    shadow
                    appearance-none
                    border
                    rounded
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline"
                        name="password"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="password"
                    />
                    <a class="button" @click="toggleShow()">
                      <v-icon v-if="showPassword">
                        mdi-eye-off
                      </v-icon>
                      <v-icon v-else>
                        mdi-eye
                      </v-icon>
                    </a>
                  </div>
                  <span class="text-gray-600 text-xs italic text-red-600">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>
              <div class="mb-6">
                <label class="block text-white-700 text-sm font-bold mb-2"
                >Confirm Password
                </label>
                <validation-provider
                    v-slot="{ errors }"
                    rules="required|confirmed:confirm"
                >
                  <div class="input-icons">
                    <input
                        v-if="showConfirmPassword"
                        v-model="confirmPassword"
                        class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                        name="confrim"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="text"
                    />
                    <input
                        v-else
                        v-model="confirmPassword"
                        class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                        name="confrim"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="password"
                    />
                    <a class="button" @click="toggleConfirmShow()">
                      <v-icon v-if="showConfirmPassword">
                        mdi-eye-off
                      </v-icon>
                      <v-icon v-else>
                        mdi-eye
                      </v-icon>
                    </a>
                  </div>
                  <span class="text-gray-600 text-xs italic text-red-600">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>

              <div class="flex items-center justify-between mb-1">
                <v-btn
                    :loading="loading"
                    class="bg-gray-200 hover:bg-blue-700 text-black font-light py-2 px-4 rounded focus:outline-none focus:shadow-outline login-button"
                    style="width: 100%"
                    type="button"
                    @click="submit"
                >Reset
                  <v-icon style="font-size: 10px"
                  >mdi-arrow-right
                  </v-icon
                  >
                </v-btn
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </Validation-Observer>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {confirmed, required} from "vee-validate/dist/rules";
import {LoginService} from "./login.service";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("confirmed", {
  ...confirmed,
  message: "Password doesn't match",
});

export default {
  name: "resetPassword",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      token: null,
      confirmPassword: null,
      loading: false,
      snackbar: false,
      resetPassword: {
        password: null,
      },
      showPassword: false,
      showConfirmPassword: false,
    };
  },

  async beforeMount() {
    this.token = this.$route.params.token;
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmShow() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async submit() {
      this.loading = true;
      if (!(await this.$refs.observer.validate())) {
        this.loading = false;
        return;
      }
      this.$refs.observer.validate();

      const res = await LoginService.resetPassword(
          this.token,
          this.resetPassword
      );
      if (res.status === 201) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.loading = false;
            this.$router.push("/login");
            break;
          case 500:
            this.$toast.error(res.data.message);
            this.loading = false;
            break;
        }
      } else {
        this.$toast.error("Unable to reset password, please try again");
        this.loading = false;
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #e2e2e5;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.form {
  background-color: #34495e;
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px #666;
  color: #ecf0f1;
  padding: 35px;
}

.vsnack {
  align-items: center;
  display: flex;
  min-height: 48px;
  justify-content: space-between;
  overflow: hidden;
  padding: 8px 16px;
  width: 100%;
}

.login-button {
  background-color: #0e74b8 !important;
  color: whitesmoke;
  font-weight: 400;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  border-radius: 4px !important;
  background-color: whitesmoke;
}

/* .input-icons i {
  position: absolute;
} */
.button {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 82%;
  padding: 10px;
}
</style>
